import React from 'react';
import { Box } from '@mui/material';
import AITrackingWidget from './AITrackingWidget';

export const AITrackingWidgetPage: React.FC = () => {
  return (
    <Box sx={{ 
      width: '100vw', 
      height: '100vh', 
      display: 'flex', 
      alignItems: 'flex-start', // Align to top
      justifyContent: 'center',
      backgroundColor: '#fff', // White bg for clean widget look
      p: 0 // No padding
    }}>
      <Box sx={{ width: '100%', height: '100%' }}>
        <AITrackingWidget />
      </Box>
    </Box>
  );
};
